module.exports = function (arg) { return arg }



//////////////////
// WEBPACK FOOTER
// ./~/empty-functions/returns-argument.js
// module id = 21
// module chunks = 0